import { Group, Text, Title } from "@mantine/core";

import { LinkButton } from "./LinkButton";

export const TitleWithLink = ({
  title,
  href,
}: {
  title: string;
  href: string;
}) => (
  <Group justify="space-between">
    <Title order={3}>{title}</Title>
    <LinkButton variant="white" href={href}>
      <Text c="dimmed" td="underline">
        View all
      </Text>
    </LinkButton>
  </Group>
);
